import { useEffect } from "react";
import { ChangeAlertCallbackType, ChangeLoaderCallbackType } from '../../Root';
import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { TextField, InputAdornment, IconButton, Divider, Alert, Box, Link } from '@mui/material';
import { useSignatureAdmin } from './hooks/useSignatureAdmin';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SearchIcon from '@mui/icons-material/Search';

export type addFeatureInextProps = {
    open: boolean;
    data?: any;
    changeAlert: ChangeAlertCallbackType;
    changeLoader: ChangeLoaderCallbackType;
}

export const SignatureAdmin = ({ open, data, changeAlert, changeLoader }: addFeatureInextProps & DefaultComponentProps) => {
    const { form, zPos, loading: loadingTable, currentAgent, search, isValidForm, dropZoneRef, newSign, onHandleChange, onHandleSearch, onConfirm, onSelectFile, handleOver, handleLeave, handleDrop, onHnadleNewSign, onClose} = useSignatureAdmin(open, data, changeAlert);

    const addFile = () => {
        document.getElementById("file").click();
    };

    useEffect(() => {
        changeLoader(loadingTable);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);

    return (
        <Dialog onClose={onClose} open={open} style={{ display: zPos !== 45 ? "none" : null, minWidth: "600px", maxHeight: "600px" }}>
            <DialogTitle>
                <Typography variant='h2'>Firma Autorizada</Typography>
            </DialogTitle>

            <DialogContent style={{paddingTop: 30}}>
                { currentAgent && currentAgent["name"] ?
                    <Alert severity={"info"}>
                        El agente con Firma Autorizada es: <b>{currentAgent['name']}</b>. Para actualizarlo, proceda a realizar la búsqueda con el Correo correspondiente.
                    </Alert>
                    :
                    <Alert severity={"info"}>
                        No existe agente con firma autorizada. A continuación ingresa el correo del Agente a asignar.
                    </Alert>
                }
				<TextField sx={{my: 2}}
                  	label="Correo electrónico" value={search} onChange={onHandleChange.bind(this)} fullWidth 
						InputProps={{
							endAdornment: <InputAdornment position='end'>
								<IconButton onClick={onHandleSearch.bind(this)}>
									<SearchIcon/>
								</IconButton>
							</InputAdornment>
						}}
						/>

                { form && form["name"] &&
                    <>
                    <Typography variant="paragraph">
                        Nuevo agente a asignar: <b>{form['name']}</b>. 
                    </Typography>
                    <Divider sx={{my: 2}}/>
                    </>
                }
                { form && form["uuid"] && (form["signature"] && !newSign ?
                    <Box my={1} display={"flex"} justifyContent={"space-between"}>
                        <Box mr={3} width={"50%"}>
                            <Typography variant="paragraph">
                                Proceda a validar la firma actual, si es correcta presione Finalizar, en caso de no corresponder presione Editar. 
                            </Typography>
                            <FlexGrid item style={{textAlign: 'start', marginTop: 15}}>
                                <Button onClick={onHnadleNewSign} size='normal'>
                                    Editar
                                </Button>
                            </FlexGrid>
                        </Box>
                        <Box component="img" alt="LogoIndigo" src={form["signature"]} height={'130px !important'} sx={{verticalAlign: "middle"}}/>
                    </Box>
                    :
                    <>
                    <Box 
                        ref={dropZoneRef} onDragLeave={handleLeave} onDragOver={handleOver} onDrop={handleDrop} onClick={addFile.bind(this, "")}
                        sx={{p: 2, mb: 1, mt: 3, border: "4px dashed lightgray", justifyItems: "center", cursor: "pointer", display: "grid"}}>
                        <Typography variant='paragraph' bold>Procede a cargar la firma digitalizada</Typography>
                        <CloudUploadIcon fontSize="large" color="action" sx={{my: 1}}/>
                        <Typography variant="paragraph">
                            Arrastra y suelta tu archivo o <Link >cárgalo desde tus documentos</Link>
                        </Typography>
                        <input id="file" type="file" accept="image/png, image/jpeg, image/jpg" style={{ display: "none" }} onChange={onSelectFile.bind(this)}/>
                    </Box>
                    <Typography variant="paragraph">Formatos válidos: .png .jpg .jpeg</Typography>
                    </>
                )}
            </DialogContent>

            <DialogActions>
                <FlexGrid fullHeight fullWidth justify='space-between' alignItems='space-between' style={{ marginTop: '20px', display: 'flex' }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType='secondary' size='normal'>
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item style={{textAlign: 'end'}}>
                        <Button onClick={() => onConfirm(form)} disabled={isValidForm} size='normal'>
                            Finalizar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    )
}

export default SignatureAdmin;
